const Flickity = require('flickity');

export default () => {

    const slider = document.querySelector('[data-hero-slider]');
    if (slider) {
        if (slider.children.length > 1) {
            const flickity = new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: false,
                pageDots: true,
                autoPlay: 5000,
                wrapAround: true
            });
        }
    }


}
